import { createClient } from "@supabase/supabase-js";
import {
  supabaseAnonKey,
  supabaseAuthEnabled,
  supabaseUrl,
} from "./leaderboard-api.js";

export const supabase = supabaseAuthEnabled
  ? createClient(supabaseUrl, supabaseAnonKey, {
      auth: {
        autoRefreshToken: true,
        detectSessionInUrl: false,
        persistSession: true,
      },
    })
  : null;
